import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { TranslatePlural } from '@change-corgi/core-react/i18n';

import { usePetitionSignatureCount } from '#src/app/pages/petitionDetails/shared/hooks';

export const SignatureStatsClosedContainer: React.FC<EmptyProps> = () => {
	const { signatureCount } = usePetitionSignatureCount();

	return (
		<Text size="small">
			<TranslatePlural
				value="fe.pages.petition_show.num_supporters_closed"
				replacements={{
					num_sigs: signatureCount.displayedLocalized,
				}}
				count={signatureCount.displayed}
			/>
		</Text>
	);
};
